class ArEditorialHeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-ar-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-ar-hero-dot]'));
    this.previousButton = this.querySelector('[data-ar-hero-prev]');
    this.nextButton = this.querySelector('[data-ar-hero-next]');
    this.pauseButton = this.querySelector('[data-ar-hero-pause]');
    this.pauseIcon = this.querySelector('[data-ar-hero-pause-icon]');
    this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplayPaused = false;
    this.interval = null;
    this.speed = Number.parseInt(this.dataset.speed, 10) || 8000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length < 2) return;

    this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1, true));
    this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1, true));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.show(Number.parseInt(dot.dataset.arHeroDot, 10), true));
    });
    this.pauseButton?.addEventListener('click', () => this.toggleAutoplay());
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    this.show(this.currentIndex, false);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    if (document.hidden) {
      this.stop();
    } else {
      this.start();
    }
  };

  show(index, userInitiated = false) {
    const nextIndex = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === nextIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.inert = !active;
    });

    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === nextIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', String(active));
    });

    this.currentIndex = nextIndex;

    if (userInitiated) {
      this.stop();
      this.start();
    }
  }

  start() {
    if (!this.autoplayEnabled || this.autoplayPaused || this.reducedMotion || document.hidden) return;
    this.stop();
    this.interval = window.setInterval(() => this.show(this.currentIndex + 1), this.speed);
  }

  stop() {
    if (!this.interval) return;
    window.clearInterval(this.interval);
    this.interval = null;
  }

  toggleAutoplay() {
    this.autoplayPaused = !this.autoplayPaused;
    this.pauseButton?.setAttribute('aria-pressed', String(this.autoplayPaused));
    this.pauseButton?.setAttribute('aria-label', this.autoplayPaused ? 'Play slideshow' : 'Pause slideshow');
    if (this.pauseIcon) this.pauseIcon.textContent = this.autoplayPaused ? '▶' : 'Ⅱ';

    if (this.autoplayPaused) {
      this.stop();
    } else {
      this.start();
    }
  }
}

if (!customElements.get('ar-editorial-hero-slider')) {
  customElements.define('ar-editorial-hero-slider', ArEditorialHeroSlider);
}
